import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Zap, Gamepad2, Users, User, Briefcase } from 'lucide-react';
import { useTelegram } from '../../hooks';

const NAV_ITEMS = [
  { path: '/home', icon: Home, label: 'Home' },
  { path: '/', icon: Briefcase, label: 'Tasks', exactMatch: true },
  { path: '/earn', icon: Zap, label: 'Earn' },
  { path: '/games', icon: Gamepad2, label: 'Games' },
  { path: '/referral', icon: Users, label: 'Friends' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export function Navigation() {
  const location = useLocation();
  const { hapticFeedback } = useTelegram();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-surface/95 backdrop-blur-lg border-t border-white/10 safe-area-inset-bottom z-50">
      <div className="w-full px-1 xs:px-2 sm:px-4">
        <div className="flex items-center justify-between xs:justify-around py-1 xs:py-1.5 sm:py-2">
          {NAV_ITEMS.map((item) => {
            // Handle exact match for root path (Tasks)
            const isActive = item.exactMatch 
              ? location.pathname === item.path || location.pathname === '/tasks'
              : location.pathname === item.path || 
                (item.path !== '/' && item.path !== '/home' && location.pathname.startsWith(item.path));
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => hapticFeedback('light')}
                className="flex flex-col items-center py-1 xs:py-1.5 sm:py-2 px-1.5 xs:px-2 sm:px-3 md:px-4 relative min-w-0 flex-1 max-w-[4.5rem] sm:max-w-[5.5rem]"
              >
                <div className="relative">
                  {isActive && (
                    <motion.div
                      layoutId="nav-indicator"
                      className="absolute inset-0 -m-1.5 xs:-m-2 bg-primary/20 rounded-lg xs:rounded-xl"
                      transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                    />
                  )}
                  <Icon
                    className={`w-5 h-5 xs:w-5.5 xs:h-5.5 sm:w-6 sm:h-6 relative z-10 transition-colors ${
                      isActive ? 'text-primary' : 'text-white/50'
                    }`}
                  />
                </div>
                <span
                  className={`text-[10px] xs:text-[11px] sm:text-xs mt-0.5 xs:mt-1 transition-colors truncate max-w-full ${
                    isActive ? 'text-primary font-medium' : 'text-white/50'
                  }`}
                >
                  {item.label}
                </span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
